export const roundNumber = number => {
  const float = parseFloat(number, 10)
  if (!float) return 0
  return parseFloat(float.toFixed(2))
}

// A quantity of 0 is worth 0, as on the server; only a missing one counts as one.
export const quantityOf = (value, fallback = 1) => {
  const quantity = parseFloat(value)
  return Number.isFinite(quantity) ? quantity : fallback
}

export const formatNumber = number => {
  if (number === null || number === undefined || !isFinite(number)) return "-"
  return number
    .toFixed(2)
    .replace(".", ",")
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ")
}

// A coefficient, at three decimals: K is a product, and two decimals hide
// 0.16 % of the price. Its two factors go through it too, so the three of them
// multiply out on screen.
//
// Twin of quotes/form/helpers.js#formatCoef — both, and the coefK Stimulus
// controller, must render exactly the same values.
export const formatCoef = number => {
  if (number === null || number === undefined || !isFinite(number)) return "-"

  // toFixed rounds on the binary representation: 1.5525 drops to 1.552 there.
  const rounded = Math.round(Math.round(number * 100000) / 100) / 1000
  return rounded.toFixed(3).replace(".", ",")
}

export const formatCurrency = (number, symbol = "€") => {
  if (number === null || number === undefined || !isFinite(number)) return "-"
  return `${formatNumber(number)}`
}

let _uidCounter = 0
export const generateUid = prefix => `${prefix}-temp-${++_uidCounter}-${Date.now()}`

// `separator` says what a line break becomes: a space for a one-line label,
// "\n" for an input field.
export const plainText = (html, separator = " ") => {
  // Parsed, never stripped with a regular expression: a single pass over
  // `<[^>]*>` leaves a `<script` behind on crafted markup, and the label ends
  // up in a title attribute.
  const doc = new DOMParser().parseFromString(html || "", "text/html")
  doc.body.querySelectorAll("br").forEach(br => br.replaceWith(separator))
  return (doc.body.textContent || "").replace(/\u00a0/g, " ").trim()
}
